import { styled } from '@styledComponents';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import { Columns } from '@components/Columns';

export const StyledBody = styled(Box)`
  width: 100%;
  margin-top: -5px;
  position: relative;
  min-height: 530px;
`;

export const StyledTextPairing = styled(TextPairing)`
  padding: ${themeSpace(4)};

  ${themeMediaQuery('below_sm')} {
    align-items: center;
    text-align: center;
  }
`;

export const ContentWrapper = styled(Flex)`
  position: relative;
  min-height: 500;
  ${themeMediaQuery('sm')} {
    border-radius: 8px;
    overflow: hidden;
  }
`;

export const TextWrapper = styled(Flex)`
  ${themeMediaQuery('below_sm')} {
    position: absolute;
  }
  ${themeMediaQuery('tablet')} {
    position: initial;
  }
`;

export const StyledFlex = styled(Flex)`
  width: 100%;
  position: relative;
  background-color: #ececea;
`;

export const DisplayAboveMobileCloudImage = styled(CloudImage)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
  ${themeMediaQuery('tablet')} {
    display: block;
  }
`;

export const DisplayOnMobileCloudImage = styled(CloudImage)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
  ${themeMediaQuery('tablet')} {
    display: none;
  }
`;

export const StyledColumns = styled(Columns)`
  flex: 1 1 0;
`;

export const StyledColumn = styled(Columns.Column)`
  text-align: center;
  align-items: center;
  ${themeMediaQuery('sm')} {
    display: flex;
  }
`;
